import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  HomologationCreateDTO,
  HomologationItem,
  HomologationsServiceInterface,
  HomologationUpdateDTO,
  PaginatedHomologationsResponse,
} from './homologations.interfaces';

@Injectable({
  providedIn: 'root',
})
export class HomologationsService {
  private readonly http = inject(HttpClient);

  private config: HomologationsServiceInterface | null = null;

  configure(config: HomologationsServiceInterface): void {
    this.config = config;
  }

  getAllHomologations(
    page: number,
    limit: number,
    name?: string,
  ): Observable<PaginatedHomologationsResponse> {
    let params = new HttpParams().set('page', page.toString()).set('limit', limit.toString());

    if (name && name.trim().length > 0) {
      params = params.set('name', name.trim());
    }

    return this.http.get<PaginatedHomologationsResponse>(
      `${this.config?.apiUrl}/api/homologations/rules/`,
      { params },
    );
  }

  getHomologationById(id: number): Observable<HomologationItem> {
    return this.http.get<HomologationItem>(`${this.config?.apiUrl}/api/homologations/rules/${id}/`);
  }

  createManualHomologation(payload: HomologationCreateDTO): Observable<HomologationItem> {
    return this.http.post<HomologationItem>(
      `${this.config?.apiUrl}/api/homologations/rules/`,
      payload,
    );
  }

  importCreateHomologation(file: File, name: string) {
    const formData = new FormData();
    formData.append('file', file, name);
    formData.append('name', name);

    return this.http.post(
      `${this.config?.apiUrl}/api/homologations/homologations/import/`,
      formData,
    );
  }

  updateHomologationById(id: number, payload: HomologationUpdateDTO): Observable<HomologationItem> {
    return this.http.patch<HomologationItem>(
      `${this.config?.apiUrl}/api/homologations/rules/${id}/`,
      payload,
    );
  }

  importUpdateHomologationById(id: number, file: File, name: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', name);

    return this.http.patch(
      `${this.config?.apiUrl}/api/homologations/homologations/import/${id}/`,
      formData,
    );
  }

  deleteHomologationById(id: number): Observable<void> {
    return this.http.delete<void>(`${this.config?.apiUrl}/api/homologations/rules/${id}/`);
  }
}
